// Textos do Confinamento da Farm (02/11/2026), coletados por glob em core/i18n/messages.ts.
export default {
  pt: {
    'farm.conf.kpi.ocupados': 'Currais ocupados',
    'farm.conf.kpi.livres': 'Currais livres',
    'farm.conf.kpi.cabecas': 'Cabeças',
    'farm.conf.kpi.clientes': 'Clientes',
    'farm.conf.kpi.saidas': 'Saídas em 15 dias',
    'farm.conf.visao': 'Visão dos currais',
    'farm.conf.perspectiva': 'Perspectiva',
    'farm.conf.grade': 'Grade numerada',
    'farm.conf.cliqueNoCurral': 'Clique num curral para filtrar a lista',
    'farm.conf.corredor': 'Corredor de trato',
    'farm.conf.livre': 'Livre',
    'farm.conf.ocupacaoHoje': 'Ocupação hoje',
    'farm.conf.legendaCliente': '{{currais}} currais, {{cabecas}} cabeças',
    'farm.conf.legendaLivres': '{{currais}} currais livres',
    'farm.conf.cabecasDe': '{{n}} de {{max}}',
    'farm.conf.nCabecas': '{{n}} cabeças',
    'farm.conf.deCapacidade': ' de {{max}}',
    'farm.conf.curral': 'Curral {{n}}',
    'farm.conf.curralOcupado': 'Curral {{n}}, {{cliente}}, {{cabecas}} cabeças',
    'farm.conf.curralLivre': 'Curral {{n}}, livre',
    'farm.conf.col.curral': 'Curral',
    'farm.conf.col.cliente': 'Cliente',
    'farm.conf.col.entrada': 'Entrada',
    'farm.conf.col.periodo': 'Entrada e saída',
    'farm.conf.col.saida': 'Saída',
    'farm.conf.col.cabecas': 'Cabeças',
    'farm.conf.col.status': 'Status',
    'farm.conf.acoes': 'Ações',
    'farm.conf.prevista': 'Prevista',
    'farm.conf.real': 'Real',
    'farm.conf.diasNoCurral': '{{n}} dias no curral',
    'farm.conf.semContrato': 'Sem contrato',
    'farm.conf.status.ativa': 'No curral',
    'farm.conf.status.saindo': 'Saída próxima',
    'farm.conf.status.atrasada': 'Saída vencida',
    'farm.conf.status.encerrada': 'Encerrada',
    'farm.conf.filtro.curral': 'Curral',
    'farm.conf.filtro.cliente': 'Cliente',
    'farm.conf.filtro.situacao': 'Situação',
    'farm.conf.filtro.abertas': 'Em aberto',
    'farm.conf.todos': 'Todos',
    'farm.conf.todas': 'Todas',
    'farm.conf.busca': 'Buscar por cliente, contrato ou curral',
    'farm.conf.ajuda': 'Cada curral é pintado pelo cliente que o aluga hoje. Clique num curral para filtrar a lista e use a grade numerada para apresentar. Os cartões de ocupados e de saídas filtram a lista. Trocar encerra o lote atual no dia e abre o do novo cliente no mesmo curral.',
    'farm.conf.excel': 'Excel',
    'farm.conf.nova': 'Nova',
    'farm.conf.saida': 'Saída',
    'farm.conf.trocar': 'Trocar',
    'farm.conf.editar': 'Editar',
    'farm.conf.historico': 'Histórico do curral',
    'farm.conf.semResultado': 'Nada para mostrar com estes filtros.',
    'farm.conf.novaTitulo': 'Nova ocupação',
    'farm.conf.editarTitulo': 'Editar ocupação do curral {{n}}',
    'farm.conf.saidaTitulo': 'Registrar saída do curral {{n}}',
    'farm.conf.trocaTitulo': 'Trocar o cliente do curral {{n}}',
    'farm.conf.escolhaCurral': 'Escolha um curral livre no desenho',
    'farm.conf.curralEscolhido': 'Curral {{n}} escolhido',
    'farm.conf.campo.cliente': 'Cliente',
    'farm.conf.campo.contrato': 'Contrato',
    'farm.conf.campo.entrada': 'Entrada',
    'farm.conf.campo.saidaPrevista': 'Saída prevista',
    'farm.conf.campo.saidaReal': 'Data da saída',
    'farm.conf.campo.cabecas': 'Cabeças',
    'farm.conf.campo.observacao': 'Observação',
    'farm.conf.campo.dataTroca': 'Data da troca',
    'farm.conf.campo.novoCliente': 'Novo cliente',
    'farm.conf.saidaResumo': '{{cliente}} sai do curral com {{cabecas}} cabeças. O curral fica livre.',
    'farm.conf.trocaResumo': 'O lote de {{cliente}} se encerra na data da troca e o novo cliente entra no mesmo curral.',
    'farm.conf.registrar': 'Registrar',
    'farm.conf.salvo': 'Ocupação salva',
    'farm.conf.saidaRegistrada': 'Saída registrada, curral {{n}} livre',
    'farm.conf.trocado': 'Cliente trocado no curral {{n}}',
    'farm.conf.erro.curral': 'Escolha o curral',
    'farm.conf.erro.cliente': 'Escolha o cliente',
    'farm.conf.erro.cabecas': 'Informe as cabeças',
    'farm.conf.hist.titulo': 'Histórico do curral {{n}}',
    'farm.conf.hist.vazio': 'Este curral ainda não teve lote',
    'farm.conf.hist.aberto': 'No curral',
    'farm.conf.fechar': 'Fechar',
  },
  en: {
    'farm.conf.kpi.ocupados': 'Pens in use',
    'farm.conf.kpi.livres': 'Free pens',
    'farm.conf.kpi.cabecas': 'Head',
    'farm.conf.kpi.clientes': 'Clients',
    'farm.conf.kpi.saidas': 'Exits in 15 days',
    'farm.conf.visao': 'Pen view',
    'farm.conf.perspectiva': 'Perspective',
    'farm.conf.grade': 'Numbered grid',
    'farm.conf.cliqueNoCurral': 'Click a pen to filter the list',
    'farm.conf.corredor': 'Feed alley',
    'farm.conf.livre': 'Free',
    'farm.conf.ocupacaoHoje': 'Occupancy today',
    'farm.conf.legendaCliente': '{{currais}} pens, {{cabecas}} head',
    'farm.conf.legendaLivres': '{{currais}} free pens',
    'farm.conf.cabecasDe': '{{n}} of {{max}}',
    'farm.conf.nCabecas': '{{n}} head',
    'farm.conf.deCapacidade': ' of {{max}}',
    'farm.conf.curral': 'Pen {{n}}',
    'farm.conf.curralOcupado': 'Pen {{n}}, {{cliente}}, {{cabecas}} head',
    'farm.conf.curralLivre': 'Pen {{n}}, free',
    'farm.conf.col.curral': 'Pen',
    'farm.conf.col.cliente': 'Client',
    'farm.conf.col.entrada': 'Entry',
    'farm.conf.col.periodo': 'Entry and exit',
    'farm.conf.col.saida': 'Exit',
    'farm.conf.col.cabecas': 'Head',
    'farm.conf.col.status': 'Status',
    'farm.conf.acoes': 'Actions',
    'farm.conf.prevista': 'Planned',
    'farm.conf.real': 'Actual',
    'farm.conf.diasNoCurral': '{{n}} days in the pen',
    'farm.conf.semContrato': 'No contract',
    'farm.conf.status.ativa': 'In the pen',
    'farm.conf.status.saindo': 'Exit soon',
    'farm.conf.status.atrasada': 'Exit overdue',
    'farm.conf.status.encerrada': 'Closed',
    'farm.conf.filtro.curral': 'Pen',
    'farm.conf.filtro.cliente': 'Client',
    'farm.conf.filtro.situacao': 'Status',
    'farm.conf.filtro.abertas': 'Open',
    'farm.conf.todos': 'All',
    'farm.conf.todas': 'All',
    'farm.conf.busca': 'Search by client, contract or pen',
    'farm.conf.ajuda': 'Each pen is painted by the client renting it today. Click a pen to filter the list and use the numbered grid to present. The in use and exits cards filter the list. Swapping closes the current lot on the date and opens the new client lot in the same pen.',
    'farm.conf.excel': 'Excel',
    'farm.conf.nova': 'New',
    'farm.conf.saida': 'Exit',
    'farm.conf.trocar': 'Swap',
    'farm.conf.editar': 'Edit',
    'farm.conf.historico': 'Pen history',
    'farm.conf.semResultado': 'Nothing to show with these filters.',
    'farm.conf.novaTitulo': 'New occupancy',
    'farm.conf.editarTitulo': 'Edit occupancy of pen {{n}}',
    'farm.conf.saidaTitulo': 'Record exit from pen {{n}}',
    'farm.conf.trocaTitulo': 'Swap the client of pen {{n}}',
    'farm.conf.escolhaCurral': 'Choose a free pen on the drawing',
    'farm.conf.curralEscolhido': 'Pen {{n}} chosen',
    'farm.conf.campo.cliente': 'Client',
    'farm.conf.campo.contrato': 'Contract',
    'farm.conf.campo.entrada': 'Entry',
    'farm.conf.campo.saidaPrevista': 'Planned exit',
    'farm.conf.campo.saidaReal': 'Exit date',
    'farm.conf.campo.cabecas': 'Head',
    'farm.conf.campo.observacao': 'Note',
    'farm.conf.campo.dataTroca': 'Swap date',
    'farm.conf.campo.novoCliente': 'New client',
    'farm.conf.saidaResumo': '{{cliente}} leaves the pen with {{cabecas}} head. The pen becomes free.',
    'farm.conf.trocaResumo': 'The {{cliente}} lot closes on the swap date and the new client enters the same pen.',
    'farm.conf.registrar': 'Record',
    'farm.conf.salvo': 'Occupancy saved',
    'farm.conf.saidaRegistrada': 'Exit recorded, pen {{n}} free',
    'farm.conf.trocado': 'Client swapped in pen {{n}}',
    'farm.conf.erro.curral': 'Choose the pen',
    'farm.conf.erro.cliente': 'Choose the client',
    'farm.conf.erro.cabecas': 'Enter the head count',
    'farm.conf.hist.titulo': 'History of pen {{n}}',
    'farm.conf.hist.vazio': 'This pen has had no lot yet',
    'farm.conf.hist.aberto': 'In the pen',
    'farm.conf.fechar': 'Close',
  },
  es: {
    'farm.conf.kpi.ocupados': 'Corrales ocupados',
    'farm.conf.kpi.livres': 'Corrales libres',
    'farm.conf.kpi.cabecas': 'Cabezas',
    'farm.conf.kpi.clientes': 'Clientes',
    'farm.conf.kpi.saidas': 'Salidas en 15 días',
    'farm.conf.visao': 'Vista de los corrales',
    'farm.conf.perspectiva': 'Perspectiva',
    'farm.conf.grade': 'Grilla numerada',
    'farm.conf.cliqueNoCurral': 'Haga clic en un corral para filtrar la lista',
    'farm.conf.corredor': 'Pasillo de alimentación',
    'farm.conf.livre': 'Libre',
    'farm.conf.ocupacaoHoje': 'Ocupación hoy',
    'farm.conf.legendaCliente': '{{currais}} corrales, {{cabecas}} cabezas',
    'farm.conf.legendaLivres': '{{currais}} corrales libres',
    'farm.conf.cabecasDe': '{{n}} de {{max}}',
    'farm.conf.nCabecas': '{{n}} cabezas',
    'farm.conf.deCapacidade': ' de {{max}}',
    'farm.conf.curral': 'Corral {{n}}',
    'farm.conf.curralOcupado': 'Corral {{n}}, {{cliente}}, {{cabecas}} cabezas',
    'farm.conf.curralLivre': 'Corral {{n}}, libre',
    'farm.conf.col.curral': 'Corral',
    'farm.conf.col.cliente': 'Cliente',
    'farm.conf.col.entrada': 'Entrada',
    'farm.conf.col.periodo': 'Entrada e saída',
    'farm.conf.col.saida': 'Salida',
    'farm.conf.col.cabecas': 'Cabezas',
    'farm.conf.col.status': 'Estado',
    'farm.conf.acoes': 'Acciones',
    'farm.conf.prevista': 'Prevista',
    'farm.conf.real': 'Real',
    'farm.conf.diasNoCurral': '{{n}} días en el corral',
    'farm.conf.semContrato': 'Sin contrato',
    'farm.conf.status.ativa': 'En el corral',
    'farm.conf.status.saindo': 'Salida próxima',
    'farm.conf.status.atrasada': 'Salida vencida',
    'farm.conf.status.encerrada': 'Cerrada',
    'farm.conf.filtro.curral': 'Corral',
    'farm.conf.filtro.cliente': 'Cliente',
    'farm.conf.filtro.situacao': 'Situación',
    'farm.conf.filtro.abertas': 'Abiertas',
    'farm.conf.todos': 'Todos',
    'farm.conf.todas': 'Todas',
    'farm.conf.busca': 'Buscar por cliente, contrato o corral',
    'farm.conf.ajuda': 'Cada corral se pinta por el cliente que lo alquila hoy. Haga clic en un corral para filtrar la lista y use la grilla numerada para presentar. Las tarjetas de ocupados y de salidas filtran la lista. Cambiar cierra el lote actual en la fecha y abre el del nuevo cliente en el mismo corral.',
    'farm.conf.excel': 'Excel',
    'farm.conf.nova': 'Nueva',
    'farm.conf.saida': 'Salida',
    'farm.conf.trocar': 'Cambiar',
    'farm.conf.editar': 'Editar',
    'farm.conf.historico': 'Historial del corral',
    'farm.conf.semResultado': 'Nada para mostrar con estos filtros.',
    'farm.conf.novaTitulo': 'Nueva ocupación',
    'farm.conf.editarTitulo': 'Editar ocupación del corral {{n}}',
    'farm.conf.saidaTitulo': 'Registrar salida del corral {{n}}',
    'farm.conf.trocaTitulo': 'Cambiar el cliente del corral {{n}}',
    'farm.conf.escolhaCurral': 'Elija un corral libre en el dibujo',
    'farm.conf.curralEscolhido': 'Corral {{n}} elegido',
    'farm.conf.campo.cliente': 'Cliente',
    'farm.conf.campo.contrato': 'Contrato',
    'farm.conf.campo.entrada': 'Entrada',
    'farm.conf.campo.saidaPrevista': 'Salida prevista',
    'farm.conf.campo.saidaReal': 'Fecha de salida',
    'farm.conf.campo.cabecas': 'Cabezas',
    'farm.conf.campo.observacao': 'Observación',
    'farm.conf.campo.dataTroca': 'Fecha del cambio',
    'farm.conf.campo.novoCliente': 'Nuevo cliente',
    'farm.conf.saidaResumo': '{{cliente}} sale del corral con {{cabecas}} cabezas. El corral queda libre.',
    'farm.conf.trocaResumo': 'El lote de {{cliente}} se cierra en la fecha del cambio y el nuevo cliente entra en el mismo corral.',
    'farm.conf.registrar': 'Registrar',
    'farm.conf.salvo': 'Ocupación guardada',
    'farm.conf.saidaRegistrada': 'Salida registrada, corral {{n}} libre',
    'farm.conf.trocado': 'Cliente cambiado en el corral {{n}}',
    'farm.conf.erro.curral': 'Elija el corral',
    'farm.conf.erro.cliente': 'Elija el cliente',
    'farm.conf.erro.cabecas': 'Informe las cabezas',
    'farm.conf.hist.titulo': 'Historial del corral {{n}}',
    'farm.conf.hist.vazio': 'Este corral aún no tuvo lote',
    'farm.conf.hist.aberto': 'En el corral',
    'farm.conf.fechar': 'Cerrar',
  },
}
